import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import eventBus from 'vue3-eventbus'
import Antd from 'ant-design-vue'
import VueClipboard from 'vue-clipboard2';

createApp(App).use(store).use(eventBus).use(router).use(Antd).use(VueClipboard).mount('#app')
